import ServiceBlock from "components/Services/ServiceBlock";
import ServiceHero from "components/Services/ServiceHero";
import Contact from "components/home/Contact";
import Footer from "components/home/Footer";
import Header from "components/home/Header";
import InfoBlock from "components/Services/InfoBlock";
import ServiceCenterTextBlock from "components/Services/ServiceCenterTextBlock";

const CommunityAndMentorship = () => {
  const pageData = {
    hero: {
      title: "Community & Mentorship",
      description:
        "Dedication to empowering others and fostering community growth makes communities comes to life.",
      bgImgClass:
        "md:bg-[url('assets/services/hero-images/community-and-mentorship.png')] bg-[url('assets/services/hero-images/community-mobile.png')]",
    },
    serviceBlocks: [
      {
        svg: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            viewBox="0 0 115 124"
            fill="none"
          >
            <rect
              x="0.689453"
              y="0.850464"
              width="100%"
              height="122.197"
              rx="20.1978"
              fill="url(#paint0_linear_669_9)"
            />
            <g clip-path="url(#clip0_669_9)">
              <path
                d="M62.1766 76.1176C60.3531 74.8627 58.5295 73.6078 56.706 72.3922C56.4707 72.2353 56.0982 72.1961 55.7844 72.1961C52.2942 72.1765 48.7844 72.1569 45.2942 72.2157C44.8433 72.2157 44.2942 72.4902 43.9609 72.8039C41.0197 75.6863 38.1178 78.6078 35.2158 81.5294C35.0982 81.6471 35.0001 81.8235 34.8629 81.8627C34.3531 82 33.7648 82.2745 33.3531 82.1176C33.0001 81.9804 32.6472 81.3333 32.6472 80.8824C32.5884 78.3922 32.608 75.9216 32.608 73.4314C32.608 73.0588 32.608 72.6667 32.608 72.1765C31.7452 72.1765 31.0001 72.1765 30.255 72.1765C25.804 72.1569 22.4903 68.8627 22.4707 64.451C22.4707 55.2941 22.4707 46.1373 22.4707 36.9804C22.4707 32.1569 25.6276 29 30.4511 29C45.804 29 61.1766 29 76.5295 29C79.5295 29 82.5491 29 85.5491 29C90.3727 29.0196 93.5099 32.1765 93.5099 37C93.5099 46.0588 93.5099 55.098 93.5099 64.1569C93.5099 68.9216 90.2746 72.2157 85.5295 72.1373C83.5884 72.1176 81.8825 72.2549 80.3335 73.7059C79.2942 74.6863 77.8433 75.2353 76.6864 75.902C78.2158 76.8824 79.9217 77.7647 81.3727 78.9608C85.9217 82.6471 88.255 87.4902 88.4511 93.3333C88.4903 94.549 88.0589 94.9804 86.804 94.9804C75.1962 94.9804 63.608 94.9804 52.0001 94.9804C50.7256 94.9804 50.2942 94.549 50.3531 93.2353C50.7844 85.5098 54.4903 79.9216 61.3727 76.451C61.6864 76.3137 62.0001 76.1961 62.1766 76.1176ZM69.3923 41.7059C60.2354 41.7255 52.9021 49.098 52.9217 58.2549C52.9413 67.3529 60.4119 74.7647 69.4903 74.7255C78.5295 74.6863 85.9217 67.2353 85.9217 58.1961C85.9413 49.0588 78.5295 41.6863 69.3923 41.7059Z"
                fill="white"
              />
              <path
                d="M80.8436 58.3334C80.7456 64.6863 75.5691 69.7255 69.2358 69.6275C62.8436 69.5294 57.9024 64.3137 58.0005 57.7647C58.0789 51.7255 63.4514 46.6275 69.6083 46.7255C75.8632 46.8432 80.9416 52.0785 80.8436 58.3334Z"
                fill="white"
              />
            </g>
            <defs>
              <linearGradient
                id="paint0_linear_669_9"
                x1="92.5893"
                y1="0.850463"
                x2="57.7482"
                y2="123.047"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#FFC44D" />
                <stop offset="1" stop-color="#FFC44D" />
              </linearGradient>
              <clipPath id="clip0_669_9">
                <rect
                  width="71.0588"
                  height="66"
                  fill="white"
                  transform="translate(22.4707 29)"
                />
              </clipPath>
            </defs>
          </svg>
        ),
        title: "Personalized Guidance",
        description:
          "I offer one-on-one mentorship for young professionals & aspiring entrepreneurs. Sharing insights from my career’s early challenges to becoming the youngest member of the Board of Directors at FIU.",
      },
      {
        svg: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            viewBox="0 0 115 124"
            fill="none"
          >
            <rect
              x="0.689453"
              y="0.850342"
              width="100%"
              height={"122"}
              rx="20.1978"
              fill="url(#paint0_linear_669_10)"
            />
            <g clip-path="url(#clip0_669_10)">
              <path
                d="M57.474 96.0001C46.9343 96.0001 36.3772 96.0001 25.8375 96.0001C24.2254 96.0001 24 95.7747 24 94.1279C24 92.0823 24 90.0195 24 87.9739C24 86.8125 24.3814 86.4311 25.5602 86.4311C29.2525 86.4311 32.9622 86.4311 36.6546 86.4311C38.6828 86.4311 39.5322 85.5644 39.5322 83.5188C39.5322 81.872 39.5322 80.2252 39.5322 78.5783C39.5322 77.2089 39.8789 76.8795 41.2137 76.8795C44.8887 76.8795 48.5464 76.8795 52.2215 76.8795C54.1803 76.8795 55.0644 75.9781 55.0818 74.0192C55.0818 72.3204 55.0818 70.6042 55.0818 68.9054C55.0818 67.7439 55.4978 67.3105 56.6246 67.3105C67.5803 67.3105 78.5188 67.3105 89.4745 67.3105C90.6706 67.3105 91 67.6572 91 68.888C91 77.3822 91 85.8764 91 94.3706C91 95.7054 90.7053 96.0001 89.3705 96.0001C78.7441 96.0001 68.1004 96.0001 57.474 96.0001Z"
                fill="white"
              />
              <path
                d="M50.3491 47.8606C50.6612 47.5659 50.9559 47.2712 51.2679 46.9939C53.1401 45.3297 55.0296 43.6655 56.9018 41.984C58.5486 40.4932 58.5486 38.9677 56.9018 37.5116C55.0123 35.8128 53.1054 34.1313 51.2159 32.4498C50.9212 32.1897 50.6438 31.9124 50.1758 31.479C57.1445 31.479 63.8705 31.479 70.6311 31.479C70.6311 36.9916 70.6311 42.4868 70.6311 48.0687C63.8878 48.0687 57.1618 48.0687 50.4531 48.0687C50.4185 47.9993 50.3838 47.93 50.3491 47.8606Z"
                fill="white"
              />
              <path
                d="M62.3279 64.8491C62.3279 63.9823 62.2239 63.1329 62.3799 62.3355C62.4493 61.9368 62.9866 61.6074 63.368 61.3127C63.524 61.1914 63.8187 61.278 64.0441 61.278C70.8568 61.278 77.6694 61.278 84.4648 61.278C85.8862 61.278 86.233 61.6421 86.2503 63.0809C86.2503 63.6529 86.2503 64.225 86.2503 64.8491C78.2415 64.8491 70.3194 64.8491 62.3279 64.8491Z"
                fill="white"
              />
              <path
                d="M75.4158 58.851C74.6184 58.851 73.9077 58.851 73.0756 58.851C73.0756 58.5043 73.0756 58.2096 73.0756 57.8976C73.0756 48.866 73.0756 39.8171 73.0756 30.7855C73.0756 30.4908 72.9889 30.1268 73.1276 29.9361C73.4223 29.5721 73.8037 29.156 74.2197 29.0347C74.7744 28.8787 75.2078 29.2427 75.3638 29.8321C75.4331 30.0748 75.4505 30.3522 75.4505 30.5949C75.4505 39.7998 75.4505 49.022 75.4505 58.2269C75.4678 58.4176 75.4331 58.5736 75.4158 58.851Z"
                fill="white"
              />
            </g>
            <defs>
              <linearGradient
                id="paint0_linear_669_10"
                x1="91.5794"
                y1="5.89979"
                x2="64.3124"
                y2="89.7206"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#FFC44D" />
                <stop offset="1" stop-color="#FFC44D" />
              </linearGradient>
              <clipPath id="clip0_669_10">
                <rect
                  width="67"
                  height="67"
                  fill="white"
                  transform="translate(24 29)"
                />
              </clipPath>
            </defs>
          </svg>
        ),
        title: "Career Development",
        description:
          " I will offer advice on career paths, skill development, and professional growth. as well as help mentees navigate the corporate world while staying true to their authentic selves.",
      },
      {
        svg: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            viewBox="0 0 115 124"
            fill="none"
          >
            <rect
              x="0.689453"
              y="0.850586"
              width="100%"
              height={"122"}
              rx="20.1978"
              fill="#FFC44D"
            />
            <g clip-path="url(#clip0_669_11)">
              <path
                d="M68.9603 45.2073C73.7403 50.1743 81.5689 50.4687 86.7629 45.2073C88.4754 46.7526 89.6045 48.6106 89.8303 50.8918C89.9997 52.6762 90.0185 54.4975 89.9244 56.3004C89.8115 58.5815 88.1366 60.2004 85.7843 60.2188C80.4962 60.274 75.1893 60.274 69.9013 60.2188C67.436 60.182 65.7423 58.3976 65.7611 56.0244C65.7611 54.1664 65.7423 52.2899 65.9681 50.4319C66.2128 48.3531 67.3419 46.6606 68.9603 45.2073Z"
                fill="white"
              />
              <path
                d="M46.0018 45.189C47.9589 46.9366 49.0504 49.0522 49.201 51.5725C49.295 53.1546 49.2574 54.7551 49.2198 56.3556C49.1633 58.4896 47.432 60.1821 45.1173 60.2189C39.7916 60.2741 34.4659 60.2925 29.1402 60.2189C26.7502 60.1821 25.1129 58.508 25.0377 56.1533C24.9812 54.4976 25 52.8419 25.1129 51.2046C25.2447 48.997 26.4491 46.7895 28.2557 45.2442C30.6645 47.6541 33.6002 49.0522 37.1381 49.0522C40.6384 49.0522 43.5553 47.6909 46.0018 45.189Z"
                fill="white"
              />
              <path
                d="M48.561 81.0622C54.0184 86.4708 61.6965 85.8637 66.4576 80.9702C67.1163 81.8348 67.9443 82.5891 68.3583 83.5273C68.9417 84.8887 69.3557 86.3604 69.5815 87.8137C69.7885 89.1567 69.6756 90.5732 69.6192 91.9345C69.5251 94.3813 67.8126 95.9817 65.3285 95.9817C60.0969 96.0001 54.8652 96.0001 49.6336 95.9817C47.206 95.9817 45.3994 94.3629 45.3994 91.9897C45.3994 89.7453 45.5311 87.4642 45.8887 85.2566C46.1522 83.6009 47.2437 82.258 48.561 81.0622Z"
                fill="white"
              />
              <path
                d="M57.5003 64.8181C62.3555 64.8549 66.1946 68.663 66.1381 73.4093C66.0816 78.0084 62.0921 81.8349 57.4062 81.7613C52.5886 81.6877 48.7684 77.8796 48.8248 73.1885C48.8625 68.5526 52.7768 64.7813 57.5003 64.8181Z"
                fill="white"
              />
              <path
                d="M37.1005 29C41.8993 29 45.776 32.7713 45.8136 37.444C45.8324 42.0431 41.8617 45.9248 37.1005 45.9248C32.3205 45.9248 28.4627 42.0983 28.4815 37.3888C28.5003 32.7161 32.3205 29 37.1005 29Z"
                fill="white"
              />
              <path
                d="M86.4812 37.5176C86.4812 42.1352 82.5669 45.9248 77.8434 45.9248C73.1011 45.9064 69.1492 42.0248 69.1868 37.4073C69.2244 32.7346 73.1199 28.9817 77.9187 29.0001C82.7363 29.0185 86.5001 32.7713 86.4812 37.5176Z"
                fill="white"
              />
              <path
                d="M71.5957 82.5522C71.0499 81.7244 70.4854 80.8966 69.9961 80.1423C71.5204 78.8546 73.1012 77.6772 74.475 76.3342C77.9 72.9677 79.9889 68.8837 80.7981 64.1926C80.911 63.5487 81.1368 63.2727 81.8143 63.3279C82.4917 63.3831 83.188 63.3463 83.8843 63.3647C83.9784 63.3647 84.0537 63.4199 84.129 63.4567C84.4865 69.3252 77.2225 80.3999 71.5957 82.5522Z"
                fill="white"
              />
              <path
                d="M45.0233 80.0686C44.4964 80.8781 43.9507 81.6875 43.4237 82.5154C38.305 81.154 30.834 69.8586 30.834 63.3462C31.7561 63.3462 32.6782 63.3095 33.6192 63.3646C33.8073 63.383 34.0708 63.6958 34.1084 63.8981C35.294 70.7784 39.0013 76.0582 44.9104 79.8847C44.9481 79.9215 44.9669 79.9767 45.0233 80.0686Z"
                fill="white"
              />
              <path
                d="M65.9493 38.5479C60.2849 36.5795 54.6769 36.5611 49.0689 38.5295C48.9936 37.5177 48.8619 36.6163 48.8807 35.6965C48.8807 35.4573 49.3136 35.1078 49.6147 35.0158C54.357 33.6177 59.1369 33.4337 63.9546 34.6479C64.6132 34.8134 65.4789 34.8502 65.8741 35.2733C66.194 35.6229 65.9493 36.4507 65.9493 37.0762C65.9493 37.5361 65.9493 37.996 65.9493 38.5479Z"
                fill="white"
              />
            </g>
            <defs>
              <clipPath id="clip0_669_11">
                <rect
                  width="65"
                  height="67"
                  fill="white"
                  transform="translate(25 29)"
                />
              </clipPath>
            </defs>
          </svg>
        ),
        title: "Networking Opportunities",
        description:
          "I will connect mentees with industry leaders and professionals and facilitate meaningful relationships that can open doors and create opportunities.",
      },
      {
        svg: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            viewBox="0 0 123 132"
            fill="none"
          >
            <g filter="url(#filter0_d_669_12)">
              <rect
                x="4.68945"
                y="0.850586"
                width="100%"
                height={"122"}
                rx="20.1978"
                fill="url(#paint0_linear_669_12)"
              />
              <g clip-path="url(#clip0_669_12)">
                <path
                  d="M37.8289 52.9983C37.9264 52.9197 38.0433 52.8411 38.1408 52.7428C38.3552 52.9 38.5696 53.0376 38.7645 53.1949C41.6685 55.3569 44.8259 57.0275 48.3732 57.7351C50.3027 58.1281 52.2907 58.3247 54.2592 58.3444C56.2667 58.364 57.4751 56.4772 56.8125 54.6689C56.4226 53.5486 55.4286 52.9 54.0448 52.9197C50.79 52.9787 47.7105 52.2318 44.9234 50.5808C43.1888 49.5391 41.5711 48.2419 40.0119 46.9447C38.0628 45.333 35.9579 44.7434 33.5996 45.6672C31.2023 46.6302 29.76 48.4778 29.721 51.0722C29.643 57.7744 29.682 64.4962 29.721 71.2181C29.7405 75.2276 32.6445 78.1365 36.64 78.1365C39.6221 78.1365 42.6236 78.1561 45.6056 78.0775C46.5411 78.0579 46.8724 78.333 47.0868 79.2371C48.1393 83.6201 49.2307 88.0031 50.3807 92.3467C50.9654 94.548 53.0313 95.5504 55.0194 94.7053C56.5786 94.037 57.2412 92.6219 56.9879 90.5582C56.2862 84.6422 55.5846 78.7261 54.9024 72.8298C54.649 70.7071 53.3822 69.233 51.2967 68.8988C49.6011 68.6237 47.8859 68.5058 46.1708 68.3289C44.4167 68.152 42.643 67.9751 40.8889 67.7982C40.8889 67.2479 40.8694 66.8351 40.8889 66.4027C41.0643 63.6904 41.2592 60.9781 41.4736 58.2854C41.5321 57.6564 41.3567 57.2437 40.8889 56.7523C39.778 55.5534 38.823 54.2562 37.8289 52.9983ZM82.1888 67.7196C81.9159 67.7982 81.799 67.8375 81.6625 67.8572C78.7 68.152 75.718 68.4664 72.736 68.7023C69.8904 68.9382 68.4286 70.2747 68.0778 73.1246C67.6295 76.6624 67.2008 80.2002 66.772 83.738C66.4991 86.0376 66.2457 88.3569 65.9924 90.6564C65.7585 92.7398 66.5381 94.2139 68.1558 94.7839C70.2217 95.5111 72.1318 94.3711 72.736 91.9536C73.8274 87.6689 74.8994 83.4039 75.9129 79.1192C76.1078 78.2741 76.4586 78.0579 77.2772 78.0775C80.3957 78.1365 83.5141 78.1561 86.6325 78.1168C90.1408 78.0775 93.1813 75.2473 93.2202 71.7684C93.2982 64.8697 93.2982 57.9513 93.2592 51.0329C93.2397 48.5564 91.5831 46.4533 89.1858 45.5689C86.9834 44.7631 84.3717 45.4313 82.754 47.1806C82.4616 47.495 82.1888 47.8095 81.8574 48.0847C78.0179 51.1901 73.7105 53.018 68.7015 52.9393C67.2592 52.9197 66.2068 53.8631 65.9924 55.2586C65.7975 56.4968 66.5576 57.853 67.766 58.2068C68.4092 58.4033 69.1108 58.423 69.793 58.4033C75.0943 58.2657 79.7915 56.4182 84.0598 53.3128C84.3327 53.1162 84.6056 52.9197 84.8784 52.7231C84.9369 52.8018 85.0149 52.8607 85.0733 52.9393C84.3717 53.9221 83.8649 55.121 82.9489 55.8089C81.4286 56.9882 81.3702 58.4033 81.6041 60.0346C81.6235 60.1722 81.643 60.2901 81.643 60.4277C81.8574 62.8256 82.0134 65.2431 82.1888 67.7196ZM63.2637 65.5969C63.7315 65.5969 64.0628 65.5969 64.4137 65.5969C67.1423 65.5969 69.8709 65.5969 72.5996 65.5969C73.4766 65.5969 74.3537 65.6165 75.2307 65.5772C76.2637 65.5379 76.9849 64.8304 77.0238 63.8869C77.0628 63.0025 76.4002 62.236 75.4256 62.0591C75.2113 62.0198 74.9774 62.0198 74.7435 62.0198C65.9144 62.0198 57.0658 62.0198 48.2367 62.0198C47.8274 62.0198 47.3792 62.0591 47.0089 62.2163C46.2487 62.5308 45.8394 63.1794 45.9564 64.0245C46.0733 64.8893 46.5996 65.4396 47.4961 65.5576C47.7885 65.5969 48.0808 65.5772 48.3732 65.5772C51.784 65.5772 55.1948 65.5772 58.6056 65.5772C58.9564 65.5772 59.2877 65.6165 59.697 65.6362C59.697 66.1276 59.697 66.5206 59.697 66.9137C59.697 74.8738 59.697 82.8339 59.697 90.794C59.697 91.0888 59.697 91.3837 59.697 91.6785C59.736 92.7988 60.4961 93.6243 61.4901 93.6046C62.4841 93.585 63.2053 92.7791 63.2442 91.6392C63.2442 91.3444 63.2442 91.0495 63.2442 90.7547C63.2442 82.7946 63.2442 74.8345 63.2442 66.8744C63.2637 66.501 63.2637 66.1079 63.2637 65.5969ZM35.802 29.0001C32.1183 28.9804 29.0583 32.0269 28.9999 35.7809C28.9414 39.4956 31.9429 42.5814 35.7045 42.6797C39.3882 42.7583 42.5651 39.5939 42.5651 35.8399C42.5651 32.1252 39.5051 29.0197 35.802 29.0001ZM87.2562 29.0001C83.5726 28.9804 80.4736 32.0662 80.4346 35.7809C80.3957 39.5153 83.5336 42.6993 87.2562 42.66C90.9789 42.6404 94.0193 39.5742 93.9999 35.8202C93.9999 32.1055 90.9594 29.0197 87.2562 29.0001Z"
                  fill="white"
                />
                <path
                  d="M37.8287 52.9984C38.8422 54.2563 39.7973 55.5535 40.8887 56.7327C41.337 57.2241 41.5124 57.6368 41.4734 58.2658C41.259 60.9781 41.0836 63.6905 40.8887 66.3831C40.8692 66.7959 40.8887 67.2283 40.8887 67.7786C42.6623 67.9555 44.4164 68.1127 46.1706 68.3093C47.8857 68.4862 49.6009 68.6041 51.2965 68.8793C53.382 69.2134 54.6488 70.6875 54.9022 72.8102C55.5844 78.7262 56.286 84.6422 56.9877 90.5386C57.241 92.622 56.5784 94.0371 55.0191 94.6857C53.0311 95.5308 50.9652 94.5285 50.3805 92.3271C49.2305 87.9638 48.1391 83.6005 47.0866 79.2176C46.8722 78.3134 46.5409 78.0383 45.6053 78.0579C42.6233 78.1366 39.6218 78.1169 36.6398 78.1169C32.6443 78.1169 29.7403 75.208 29.7208 71.1985C29.6818 64.4766 29.6428 57.7744 29.7208 51.0526C29.7598 48.4582 31.2021 46.6106 33.5994 45.6672C35.9577 44.7238 38.0626 45.3134 40.0116 46.9448C41.5709 48.242 43.1691 49.5588 44.9232 50.5809C47.7103 52.2318 50.7898 52.9787 54.0446 52.9198C55.4284 52.9001 56.403 53.5487 56.8122 54.669C57.4554 56.4969 56.2665 58.3641 54.259 58.3444C52.2905 58.3248 50.3025 58.1282 48.373 57.7351C44.8257 57.0079 41.6683 55.3569 38.7643 53.1949C38.5499 53.0377 38.355 52.9001 38.1406 52.7429C38.0236 52.8411 37.9262 52.9198 37.8287 52.9984Z"
                  fill="white"
                />
                <path
                  d="M82.1891 67.7196C82.0137 65.2627 81.8578 62.8452 81.6824 60.4277C81.6824 60.2901 81.6629 60.1722 81.6434 60.0346C81.4095 58.4033 81.468 56.9685 82.9882 55.8089C83.8848 55.121 84.411 53.9024 85.1127 52.9393C85.0542 52.8607 84.9762 52.8018 84.9178 52.7231C84.6449 52.9197 84.372 53.1162 84.0992 53.3128C79.8308 56.4182 75.1336 58.2657 69.8323 58.4033C69.1501 58.423 68.4485 58.4033 67.8053 58.2068C66.5969 57.853 65.8368 56.4968 66.0317 55.2586C66.2461 53.8631 67.2986 52.9197 68.7408 52.9393C73.7498 53.0376 78.0572 51.1901 81.8968 48.0847C82.2281 47.8291 82.501 47.495 82.7933 47.1805C84.3915 45.4313 87.0227 44.763 89.2251 45.5689C91.6029 46.4533 93.2791 48.5564 93.2986 51.0328C93.3375 57.9512 93.357 64.85 93.2596 71.7684C93.2206 75.2276 90.1801 78.0775 86.6719 78.1168C83.5534 78.1365 80.435 78.1365 77.3166 78.0775C76.498 78.0579 76.1471 78.2741 75.9522 79.1192C74.9387 83.4039 73.8473 87.6886 72.7753 91.9536C72.1711 94.3711 70.2611 95.5111 68.1951 94.7839C66.5579 94.1943 65.7978 92.7398 66.0317 90.6564C66.2851 88.3568 66.5384 86.0376 66.8113 83.738C67.2401 80.2002 67.6689 76.6624 68.1172 73.1246C68.468 70.2747 69.9298 68.9381 72.7753 68.7023C75.7573 68.4468 78.7199 68.1323 81.7019 67.8571C81.7993 67.8375 81.9163 67.7785 82.1891 67.7196Z"
                  fill="white"
                />
                <path
                  d="M63.2637 65.5969C63.2637 66.1079 63.2637 66.501 63.2637 66.8744C63.2637 74.8345 63.2637 82.7946 63.2637 90.7547C63.2637 91.0495 63.2637 91.3443 63.2637 91.6391C63.2247 92.7791 62.523 93.5849 61.5095 93.6046C60.5155 93.6243 59.7554 92.8184 59.7164 91.6784C59.6969 91.3836 59.7164 91.0888 59.7164 90.794C59.7164 82.8339 59.7164 74.8738 59.7164 66.9137C59.7164 66.5206 59.7164 66.1275 59.7164 65.6362C59.3071 65.6165 58.9563 65.5772 58.625 65.5772C55.2142 65.5772 51.8034 65.5772 48.3926 65.5772C48.1002 65.5772 47.8079 65.5969 47.5155 65.5575C46.619 65.4396 46.0927 64.8893 45.9758 64.0245C45.8589 63.1793 46.2681 62.5504 47.0283 62.2163C47.3986 62.059 47.8469 62.0197 48.2562 62.0197C57.0852 62.0001 65.9338 62.0197 74.7629 62.0197C74.9968 62.0197 75.2307 62.0197 75.4451 62.059C76.4001 62.2359 77.0627 63.0024 77.0433 63.8869C77.0043 64.8303 76.2831 65.5379 75.2502 65.5772C74.3731 65.6165 73.496 65.5969 72.619 65.5969C69.8903 65.5969 67.1617 65.5969 64.4331 65.5969C64.0822 65.5969 63.7314 65.5969 63.2637 65.5969Z"
                  fill="white"
                />
                <path
                  d="M35.802 29.0001C39.5051 29.0197 42.5651 32.1252 42.5651 35.8399C42.5651 39.5939 39.3882 42.7583 35.685 42.6797C31.9429 42.601 28.9414 39.5153 28.9999 35.7809C29.0583 32.0269 32.1183 28.9804 35.802 29.0001Z"
                  fill="white"
                />
                <path
                  d="M87.2565 29.0001C90.9597 29.0197 94.0001 32.1055 94.0001 35.8399C94.0001 39.5742 90.9792 42.66 87.2565 42.6797C83.5339 42.6993 80.3959 39.5349 80.4349 35.8006C80.4739 32.0662 83.5729 28.9804 87.2565 29.0001Z"
                  fill="white"
                />
              </g>
            </g>
            <defs>
              <filter
                id="filter0_d_669_12"
                x="0.689453"
                y="0.850586"
                width="122.117"
                height="130.197"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_669_12"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_669_12"
                  result="shape"
                />
              </filter>
              <linearGradient
                id="paint0_linear_669_12"
                x1="96.5893"
                y1="0.850585"
                x2="61.7482"
                y2="123.047"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#FFC44D" />
                <stop offset="1" stop-color="#FFC44D" />
              </linearGradient>
              <clipPath id="clip0_669_12">
                <rect
                  width="65"
                  height="66"
                  fill="white"
                  transform="translate(29 29)"
                />
              </clipPath>
            </defs>
          </svg>
        ),
        title: "Financial Literacy Workshops",
        description:
          "I will conduct workshops to educate communities on managing finances, investing, and building wealth as well as empowering individuals with the knowledge to make informed financial decisions.",
      },
      {
        svg: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            viewBox="0 0 115 124"
            fill="none"
          >
            <rect
              x="0.689453"
              y="0.850342"
              width="100%"
              height={"122"}
              rx="20.1978"
              fill="url(#paint0_linear_669_13)"
            />
            <g clip-path="url(#clip0_669_13)">
              <path
                d="M55.6367 87.4441C55.9067 85.8601 55.4567 84.6949 54.1067 83.912C52.6128 83.0563 51.5508 84.003 50.4169 84.7495C50.2009 84.4582 50.0029 84.1487 49.7689 83.8756C48.7789 82.7103 47.375 82.419 46.151 83.3112C45.035 84.1305 44.0811 85.1865 43.0911 86.0968C40.1752 83.9666 37.1513 81.7636 33.9834 79.4513C35.3154 75.8099 36.7553 71.9137 38.2313 67.8535C40.3732 69.1826 42.5331 68.9823 44.963 68.1812C44.6031 68.8185 44.3511 69.2372 44.1171 69.6742C43.1451 71.5677 44.2071 73.4248 46.331 73.4977C47.7889 73.5523 49.1029 73.0607 50.2909 72.2232C50.5609 72.0411 50.8488 71.8408 51.0468 71.5859C52.6308 69.7288 54.5927 69.6924 56.7167 70.3114C59.5786 71.149 62.1885 72.5691 64.5104 74.3898C67.9843 77.1208 71.3142 80.0521 74.6981 82.9106C75.292 83.4022 75.67 83.9848 75.274 84.8223C74.8961 85.6417 74.1761 85.8783 73.4021 85.7509C72.7721 85.6417 72.1241 85.405 71.6022 85.0408C69.1182 83.2748 66.6883 81.4541 64.2404 79.6334C64.1144 79.5423 63.9884 79.3785 63.8804 79.3967C63.4664 79.4331 62.8905 79.3967 62.7285 79.6516C62.5665 79.8883 62.6745 80.5801 62.9085 80.7986C63.7724 81.5815 64.7984 82.2006 65.6624 82.9834C66.8503 84.0577 68.0023 85.1683 69.0642 86.3517C69.5502 86.8979 69.8922 87.6444 70.0362 88.3545C70.1262 88.8279 69.8742 89.5015 69.5322 89.8657C69.3162 90.0841 68.5963 90.0477 68.2363 89.8475C67.6423 89.5379 67.1563 89.0281 66.6343 88.5912C64.7084 86.9708 62.8005 85.3139 60.8205 83.7299C60.6045 83.5661 60.0465 83.8392 59.6506 83.912C59.7226 84.349 59.6506 84.9316 59.9025 85.1865C60.5865 85.8601 61.4325 86.3517 62.1705 86.9708C63.1604 87.7901 64.1684 88.6276 65.0684 89.5561C65.4284 89.9021 65.6804 90.4847 65.7344 90.9945C65.8064 91.6317 65.6084 92.2872 64.8704 92.5239C64.0604 92.7788 63.2684 92.7423 62.6025 92.1415C61.8105 91.4314 61.0365 90.7214 60.2625 90.0113C59.8126 89.6108 59.3086 89.4105 58.8406 89.9385C58.3366 90.5211 58.6426 90.9945 59.1286 91.395C59.8666 92.0141 60.6045 92.6331 61.3065 93.3068C62.0265 93.9986 61.7925 94.8361 60.8205 95C60.4245 95.0728 59.9025 94.9818 59.5426 94.7633C58.9666 94.3992 58.4806 93.8894 57.9406 93.4524C57.4906 93.1065 57.4546 92.7059 57.5986 92.1779C57.7786 91.5043 57.9046 90.7942 57.8506 90.1206C57.7426 88.7732 57.0046 87.8811 55.6367 87.4441Z"
                fill="white"
              />
              <path
                d="M76.5346 65.7783C77.5966 68.6732 78.6226 71.4771 79.6665 74.2991C79.9545 75.0638 80.2605 75.8285 80.4945 76.5932C80.5665 76.8299 80.5485 77.2487 80.4045 77.3579C78.8206 78.6506 77.1826 79.8887 75.5087 81.1813C74.3747 80.1618 73.2407 79.1058 72.0528 78.068C68.3809 74.8818 64.619 71.8048 60.1732 69.7838C58.4992 69.0191 56.6633 68.6004 54.8633 68.1998C53.1534 67.8175 51.7314 68.564 50.4175 69.6746C49.5355 70.4211 48.4915 70.9491 47.4836 71.5317C47.2496 71.6773 46.8896 71.6955 46.6016 71.6591C46.2416 71.6045 45.7376 71.5317 45.5936 71.2768C45.4496 71.0583 45.6296 70.5485 45.7916 70.2208C46.4936 68.8917 47.2136 67.5444 48.0056 66.2699C48.2576 65.8693 48.7075 65.4506 49.1395 65.3595C52.2354 64.6859 55.3313 63.8484 58.4812 63.5571C60.2272 63.3932 62.0631 64.0304 63.827 64.4856C65.501 64.9044 67.1569 65.487 68.7949 66.0878C71.0988 66.9435 73.3847 66.8343 75.6707 66.015C75.9226 65.9604 76.1926 65.8875 76.5346 65.7783Z"
                fill="white"
              />
              <path
                d="M84.3282 80.9265C84.1122 80.617 83.7882 80.3439 83.6622 80.0161C82.2583 76.2473 80.8903 72.4785 79.5043 68.6915C78.8924 67.0164 78.2984 65.3414 77.6504 63.6663C77.3804 62.9563 77.4704 62.5193 78.2264 62.2644C79.0004 62.0095 79.7563 61.7182 80.4943 61.4087C81.2863 61.0628 81.6103 61.4451 81.8803 62.1734C83.4102 66.4156 84.9582 70.6396 86.5061 74.8636C86.9561 76.0835 87.3881 77.3033 87.8561 78.5232C88.1261 79.215 87.9281 79.6156 87.2621 79.8523C86.3441 80.18 85.4262 80.5259 84.3282 80.9265Z"
                fill="white"
              />
              <path
                d="M27 80.2893C27.45 79.0148 27.846 77.9224 28.242 76.8482C29.8799 72.3875 31.5179 67.945 33.1378 63.4843C33.5518 62.3737 33.6778 62.3009 34.7937 62.7014C35.4777 62.9381 36.1257 63.2294 36.8097 63.4479C37.5477 63.6846 37.6917 64.0851 37.4217 64.8316C35.6397 69.6018 33.9118 74.372 32.1658 79.124C31.8958 79.8705 31.6438 80.5988 31.3739 81.3453C31.1579 81.9279 30.7979 82.1646 30.1859 81.9097C29.3579 81.582 28.494 81.3089 27.666 80.9447C27.378 80.8173 27.18 80.4896 27 80.2893Z"
                fill="white"
              />
              <path
                d="M62.3867 52.2321C59.1108 52.2321 55.9429 52.2321 52.703 52.2321C52.703 50.8484 52.631 49.5192 52.721 48.2084C52.793 47.1888 53.729 46.4059 54.773 46.3877C56.5909 46.3512 58.4269 46.3512 60.2448 46.3877C61.3608 46.4059 62.2967 47.2434 62.3507 48.354C62.4407 49.6103 62.3867 50.8848 62.3867 52.2321Z"
                fill="white"
              />
              <path
                d="M60.7129 58.0402C60.7129 59.8063 59.237 61.2993 57.509 61.2629C55.7991 61.2447 54.3771 59.7881 54.3771 58.0585C54.3591 56.256 55.7811 54.854 57.581 54.8722C59.327 54.8905 60.6949 56.2742 60.7129 58.0402Z"
                fill="white"
              />
              <path
                d="M41.5793 45.1499C41.5613 43.3657 42.8932 41.9819 44.6752 41.9455C46.4571 41.9091 47.9151 43.311 47.9331 45.0953C47.9511 46.825 46.4391 48.3543 44.7292 48.3543C43.0372 48.3361 41.5973 46.8978 41.5793 45.1499Z"
                fill="white"
              />
              <path
                d="M73.4749 45.2043C73.4209 46.934 71.963 48.3723 70.289 48.3541C68.5791 48.3359 67.0851 46.7701 67.1391 45.0587C67.1931 43.2744 68.6511 41.9089 70.451 41.9635C72.1969 41.9999 73.5289 43.42 73.4749 45.2043Z"
                fill="white"
              />
              <path
                d="M60.6946 32.2046C60.6766 33.9343 59.2547 35.3908 57.5447 35.409C55.8348 35.4272 54.3408 33.9161 54.3408 32.1682C54.3588 30.3657 55.7988 28.9638 57.5807 29.0002C59.3447 29.0366 60.7126 30.4568 60.6946 32.2046Z"
                fill="white"
              />
              <path
                d="M57.4909 39.3781C58.9849 39.3599 60.2088 40.8346 60.1368 42.6371C60.1188 42.9284 60.0828 43.238 60.0108 43.5293C59.6509 44.9494 58.4089 45.9508 57.2389 45.7505C55.871 45.532 54.827 44.0573 54.899 42.4369C54.989 40.7072 56.087 39.3963 57.4909 39.3781Z"
                fill="white"
              />
              <path
                d="M54.0171 86.4793C53.8911 86.9163 53.8371 87.2258 53.7111 87.4989C52.9731 89.1557 52.2172 90.7944 51.4432 92.433C50.9032 93.5618 49.8412 93.5982 49.1573 92.5422C48.6713 91.7957 48.5273 91.1585 49.0133 90.2482C49.8412 88.6824 50.3992 86.9709 51.9472 85.8967C52.3792 85.5872 52.8471 85.1502 53.3871 85.5872C53.6571 85.8239 53.8371 86.2062 54.0171 86.4793Z"
                fill="white"
              />
              <path
                d="M45.899 41.217C44.981 41.2717 44.603 40.5798 44.909 39.8151C46.025 37.1023 47.8249 34.9539 50.2908 33.4063C50.9028 33.0239 51.5508 32.7144 52.1988 32.3867C52.7388 32.1136 53.2788 32.0772 53.5847 32.7144C53.9267 33.4063 53.4947 33.7886 52.9188 34.0435C50.6868 35.0267 48.8869 36.5379 47.5549 38.5952C47.159 39.1961 46.907 39.8879 46.529 40.507C46.349 40.8347 46.043 41.0532 45.899 41.217Z"
                fill="white"
              />
              <path
                d="M62.2068 32.1138C62.5848 32.2594 62.7828 32.3323 62.9808 32.4051C66.2927 33.9345 68.6866 36.356 70.1445 39.7425C70.3965 40.3251 70.4145 40.8349 69.7846 41.1262C69.1546 41.4175 68.7586 41.0716 68.5066 40.5071C67.2286 37.4848 65.0867 35.3546 62.1348 34.0255C61.6128 33.7888 61.1988 33.4611 61.4508 32.8603C61.5768 32.5325 61.9908 32.3323 62.2068 32.1138Z"
                fill="white"
              />
              <path
                d="M62.0813 58.0585C61.9193 57.8764 61.5053 57.658 61.4513 57.3666C61.3973 57.0753 61.5953 56.602 61.8293 56.3835C62.1893 56.074 62.6753 55.9647 63.1073 55.728C65.5192 54.3807 67.3192 52.469 68.4351 49.9018C68.5071 49.738 68.5431 49.4831 68.6691 49.4284C69.0111 49.2646 69.4971 48.9733 69.7131 49.1007C70.0011 49.2828 70.3251 49.9018 70.2171 50.1567C68.7591 53.8527 66.2032 56.4745 62.5313 57.9675C62.4773 58.0221 62.3873 58.0221 62.0813 58.0585Z"
                fill="white"
              />
              <path
                d="M52.8831 58.1132C52.4871 57.9675 52.2531 57.8947 52.0371 57.7855C48.7252 56.2925 46.3493 53.8346 44.9094 50.4663C44.6574 49.8837 44.6754 49.3739 45.2874 49.0826C45.9173 48.7731 46.3133 49.1554 46.5473 49.7198C47.8433 52.7968 50.0392 54.9452 53.0451 56.2925C53.3511 56.42 53.6211 56.9844 53.6031 57.3303C53.5851 57.6216 53.1171 57.8947 52.8831 58.1132Z"
                fill="white"
              />
              <path
                d="M44.3693 89.156C44.3513 87.3535 46.0792 84.9867 47.3932 84.6407C47.9692 84.4951 48.6531 85.0049 48.7071 85.6785C48.7431 86.0244 48.7071 86.425 48.5811 86.7345C48.0772 87.9362 47.5372 89.1014 47.0152 90.2849C46.7452 90.8857 46.2952 90.9767 45.7552 90.7036C44.9453 90.3031 44.3873 89.7204 44.3693 89.156Z"
                fill="white"
              />
              <path
                d="M56.1947 90.3938C55.8887 91.6865 55.6547 92.7789 55.3307 93.8532C55.1507 94.4358 54.5748 94.5996 54.1788 94.2537C53.7468 93.8896 53.1888 93.1795 53.2968 92.8154C53.6208 91.6683 54.2328 90.5941 54.7907 89.5199C54.8627 89.3743 55.4027 89.265 55.4927 89.356C55.8167 89.6838 56.0147 90.1025 56.1947 90.3938Z"
                fill="white"
              />
              <path
                d="M38.7175 85.041C39.4555 85.6418 40.1755 86.2427 40.8955 86.8253C39.7795 87.8085 38.7355 87.8085 38.0516 86.8799C37.6016 86.2973 37.8176 85.6236 38.7175 85.041Z"
                fill="white"
              />
            </g>
            <defs>
              <linearGradient
                id="paint0_linear_669_13"
                x1="91.5794"
                y1="5.89979"
                x2="64.3124"
                y2="89.7206"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#FFC44D" />
                <stop offset="1" stop-color="#FFC44D" />
              </linearGradient>
              <clipPath id="clip0_669_13">
                <rect
                  width="61"
                  height="66"
                  fill="white"
                  transform="translate(27 29)"
                />
              </clipPath>
            </defs>
          </svg>
        ),
        title: "Local Partnerships",
        description:
          "I will collaborate with local organizations to support community development projects and volunteer my time and expertise to initiatives that uplift and empower communities.",
      },
      {
        svg: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            viewBox="0 0 115 124"
            fill="none"
          >
            <rect
              x="0.689453"
              y="0.850586"
              width="100%"
              height="122.197"
              rx="20.1978"
              fill="#FFC44D"
            />
            <g clip-path="url(#clip0_669_14)">
              <path
                d="M55.4838 96.0002C50.4384 96.0002 43.7586 94.4187 37.594 90.8063C35.32 89.4943 34.4673 87.3197 35.3378 84.8755C38.0914 77.1655 43.0835 71.6301 50.8826 69.06C59.3567 66.2564 68.7902 69.1319 74.6706 76.0871C76.8735 78.6931 78.5434 81.5866 79.6627 84.8216C80.5154 87.3377 79.6982 89.5123 77.4065 90.8422C71.2418 94.4187 64.5975 95.9823 55.4838 96.0002Z"
                fill="white"
              />
              <path
                d="M57.3669 48.6436C60.387 48.7873 63.2472 48.9491 65.9831 49.9375C66.8714 50.261 67.3866 50.8182 67.6176 51.7348C68.7013 56.066 67.7419 59.8581 64.402 62.8056C61.1331 65.6991 57.3136 66.3101 53.3163 64.5489C49.3902 62.7876 47.2228 59.6065 47.0273 55.2393C46.974 53.9274 47.2938 52.5794 47.5958 51.2855C47.7024 50.8541 48.1643 50.297 48.5729 50.1712C50.385 49.65 52.2149 49.2007 54.0625 48.8772C55.1995 48.6795 56.372 48.6975 57.3669 48.6436Z"
                fill="white"
              />
              <path
                d="M68.5945 44.582C68.5945 43.917 68.559 43.4498 68.5945 42.9825C68.7544 41.1853 67.8662 39.9991 66.285 39.4779C64.5262 38.9028 62.7142 38.3996 60.8843 38.1839C57.0825 37.7526 53.2629 37.8604 49.5677 39.1005C49.017 39.2802 48.4662 39.5498 47.951 39.8374C46.8496 40.4664 46.2988 41.4189 46.3521 42.7129C46.3699 43.2701 46.3521 43.8272 46.3521 44.5281C45.7126 44.2226 45.2151 43.9889 44.7177 43.7373C42.6392 42.677 40.5428 41.6346 38.482 40.5203C38.0912 40.3047 37.5938 39.8374 37.5938 39.4959C37.5938 39.1365 38.0912 38.6692 38.482 38.4535C43.7761 35.7218 49.0703 33.008 54.3821 30.3301C57.9708 28.515 56.9226 28.515 60.5112 30.3301C63.7801 31.9836 67.0489 33.6729 70.3356 35.3264C70.8152 35.56 70.9396 35.8835 70.9396 36.3867C70.9218 38.4176 70.904 40.4484 70.9396 42.4973C70.9573 43.1622 70.7619 43.5576 70.1401 43.8092C69.7138 44.0069 69.2341 44.2765 68.5945 44.582Z"
                fill="white"
              />
              <path
                d="M67.2447 48.8413C60.707 46.7565 54.3292 46.7385 47.8448 48.8233C47.827 48.6076 47.7737 48.356 47.7737 48.1224C47.7737 46.415 47.827 44.7077 47.756 43.0003C47.7027 41.8501 48.1823 41.0953 49.1594 40.7898C50.705 40.3045 52.2684 39.8013 53.8673 39.6036C57.3849 39.1363 60.8847 39.2621 64.3312 40.2147C64.6154 40.2865 64.8997 40.3764 65.1839 40.4842C66.9249 41.1133 67.2447 41.5626 67.2447 43.4317C67.2447 45.2109 67.2447 47.0081 67.2447 48.8413Z"
                fill="white"
              />
              <path
                d="M71.7928 36.2251C72.8409 36.4048 73.214 36.8901 73.1785 37.8965C73.1074 40.2868 73.1429 42.6771 73.1785 45.0853C73.1785 45.4807 73.4805 45.8761 73.5516 46.2895C73.6404 46.8107 73.6937 47.3498 73.7114 47.871C73.7292 48.2664 73.5516 48.6798 73.6404 49.0392C73.8536 50.0816 74.1911 51.124 74.4221 52.1664C74.5997 52.9571 74.3332 53.2986 73.5338 53.3166C72.8232 53.3345 72.1125 53.3345 71.4019 53.3166C70.6913 53.2986 70.3715 52.9212 70.5492 52.1843C70.7624 51.3756 70.9756 50.5668 71.1887 49.7581C71.3842 49.0212 71.6684 48.3383 71.1887 47.5475C71.0289 47.2779 71.2776 46.7208 71.3842 46.3074C71.4908 45.8761 71.7572 45.4448 71.775 45.0135C71.8105 42.102 71.7928 39.2085 71.7928 36.2251Z"
                fill="white"
              />
              <path
                d="M74.0488 41.8323C74.0488 40.2328 74.0488 38.831 74.0488 37.2314C75.1503 37.8066 76.1807 38.2738 77.14 38.8849C77.673 39.2263 77.6375 39.8913 77.069 40.2328C76.1452 40.8079 75.1503 41.2572 74.0488 41.8323Z"
                fill="white"
              />
            </g>
            <defs>
              <clipPath id="clip0_669_14">
                <rect
                  width="45"
                  height="67"
                  fill="white"
                  transform="translate(35 29)"
                />
              </clipPath>
            </defs>
          </svg>
        ),
        title: "Youth Programs",
        description:
          "I will engage with youth through educational programs and motivational speaking. I am passionate about empowering next generation to pursue their dreams and reach their full potential.",
      },
    ],
  };
  return (
    <main>
      <div
        className={`${pageData.hero.bgImgClass} bg-[url('assets/hero-bg.png')] bg-cover bg-no-repeat w-full bg-left-bottom h-[85vh] relative flex justify-center`}
      >
        <Header hasInitialTransparentBgOpacity />
        <ServiceHero
          title={pageData.hero.title}
          description={pageData.hero.description}
        />
      </div>
      <section className="px-[8%] py-[5%] grid grid-cols-1 items-center justify-center md:grid-cols-2 gap-5 md:gap-10  ">
        <InfoBlock
          title={"My Vision"}
          description={
            "I believe in the transformative power of mentorship and the importance of community. From my own journey, growing up in a lower-income household and navigating the complexities of finance, I've seen firsthand how guidance and support can change lives. My mission is to give back, inspire, and equip others with the tools they need to succeed."
          }
          img={require("assets/services/dimitry-my-approach.png")}
        />
        <h1 className="flex text-[8.5vw] leading-[0.7] font-secondary font-medium h-full w-full items-center text-center">
          Mentorship Programs
        </h1>
        <ServiceBlock {...pageData.serviceBlocks[0]} />
        <ServiceBlock {...pageData.serviceBlocks[1]} />
        <ServiceBlock {...pageData.serviceBlocks[2]} />
        <h1 className="flex text-[8.5vw] leading-[0.7] font-secondary font-medium h-full w-full items-center text-center">
          Community Initiatives
        </h1>
        <ServiceBlock {...pageData.serviceBlocks[3]} />
        <ServiceBlock {...pageData.serviceBlocks[4]} />
        <ServiceBlock {...pageData.serviceBlocks[5]} />
        <div></div>
        <InfoBlock
          title={"Why My Mentor?"}
          description={
            "From humble beginnings, I have achieved significant milestones in my career, I understand the value of mentorship and community support. My experiences have equipped me with the knowledge and passion to guide others on their paths to success."
          }
          img={require("assets/services/why-prophete.png")}
        />
      </section>
      <ServiceCenterTextBlock
        title={"Join the Movement"}
        bodyText={
          "Mentorship and community service are at the heart of everything I do. Whether you're looking for guidance, support, or ways to give back, I'm here to help. Together, we can create a positive impact and build a stronger, more empowered community."
        }
      />
      <Contact
        actionBtnText={"Work with me"}
        bodyText={
          "Ready to embark on this journey with me? Let's connect and make a difference together."
        }
      />
      <Footer />
    </main>
  );
};

export default CommunityAndMentorship;
